// Credits screen data: the honesty copy (spec §2, §4), the data sources and the asset-credit JSON contract.
// The per-file photo and recording credits are generated by the asset scripts into public/img/credits.json and
// public/audio/credits.json; the Credits screen fetches them at runtime (same origin, no other network use).
import type { AssetCredit } from '../types';
import { DATA_SOURCES } from './sources';

export { DATA_SOURCES };

/** Exact wording required by the design spec; shown on the Credits screen. */
export const DISCLAIMERS: readonly string[] = [
  'Modelled on published engine data. Not a flight or operating manual.',
  'Photographs from U.S. government sources are in the public domain; their use does not imply endorsement by the U.S. Department of Defense or NASA.',
];

/** The honesty line used in the store listing and on the Credits screen (spec §2). */
export const HONESTY_LINE =
  'Modelled on published engine data. Not a flight or operating manual. Real field recordings and photographs, credited on the Credits screen.';

export const PHOTO_CREDITS_URL = '/img/credits.json';
export const AUDIO_CREDITS_URL = '/audio/credits.json';

export function isAssetCredit(x: unknown): x is AssetCredit {
  if (typeof x !== 'object' || x === null) return false;
  const c = x as Record<string, unknown>;
  return (
    typeof c.file === 'string' && typeof c.title === 'string' && typeof c.author === 'string' &&
    typeof c.url === 'string' && typeof c.licence === 'string' && typeof c.licenceUrl === 'string'
  );
}

/** Keeps only well-formed entries from untrusted JSON; anything else is dropped rather than thrown. */
export function parseCredits(json: unknown): AssetCredit[] {
  if (!Array.isArray(json)) return [];
  return json.filter(isAssetCredit);
}
